import {Injectable} from '@angular/core'
import {GetCraftsmenMenuGql, GetMoreMenuGql} from '../../../../__generated__/datocms.types'
import {EMPTY, Observable} from 'rxjs'
import {DropdownMenu} from '../types/dropdown-menu.types'
import {catchError, map} from 'rxjs/operators'
import {TranslocoService} from '@ngneat/transloco'
import {getSiteLocale} from '../site-locale'
import {CMS_GRAPHQL_CLIENT_NAME} from '../content-graphql-split'
import {pickProperty} from '../../graphql/graphql-utils'
import {parseDropdownMenu} from '../serde/dropdown-menu.serde'

@Injectable()
export class DropdownMenuContentService {
  constructor(
    private readonly getCraftsmenDropdownMenuGql: GetCraftsmenMenuGql,
    private readonly getMoreDropdownMenuGql: GetMoreMenuGql,
    private readonly locale: TranslocoService,
  ) {}

  getCraftsmenDropdownMenu(): Observable<DropdownMenu> {
    return this.getCraftsmenDropdownMenuGql
      .fetch({locale: getSiteLocale(this.locale)}, {context: {clientName: CMS_GRAPHQL_CLIENT_NAME}})
      .pipe(
        map(res => pickProperty(res.data, 'componentDropdownMenuModel')),
        map(component => parseDropdownMenu(component)),
        catchError(() => EMPTY),
      )
  }

  getMoreDropdownMenu(): Observable<DropdownMenu> {
    return this.getMoreDropdownMenuGql
      .fetch({locale: getSiteLocale(this.locale)}, {context: {clientName: CMS_GRAPHQL_CLIENT_NAME}})
      .pipe(
        map(res => pickProperty(res.data, 'componentDropdownMenuModel')),
        map(component => parseDropdownMenu(component)),
        catchError(() => EMPTY),
      )
  }
}
